import React from "react"
import {Row, Col} from 'antd'
import {ArticleContainer} from './style'
import InnerHtml from '../../components/InnerHtml'
import Button from '../../components/Button'

function Article(props) {

  const content = `<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ex orci, sodales in lacus a, gravida euismod odio. Proin laoreet nisi et justo suscipit vestibulum. Duis sit amet bibendum erat, eu lobortis diam. Praesent nec arcu justo. Duis efficitur venenatis felis, non aliquam leo fringilla sed. Ut ac massa sed lorem venenatis hendrerit. Morbi suscipit volutpat lorem. In hac habitasse platea dictumst. Mauris laoreet iaculis purus, sed facilisis dolor molestie et. Sed mattis ullamcorper ligula. Aliquam ac purus ipsum. Nullam volutpat ullamcorper tellus placerat sodales. Etiam sed blandit ex. Nulla placerat euismod justo, in lacinia justo tempor at. In eu orci dignissim, vulputate nisl id, lacinia tellus.</p>

  <p>&nbsp;</p>
  <img alt="Imagem" src="https://dexco.s3.sa-east-1.amazonaws.com/images/banners/banner-dexco.jpg" style="width:50%; margin-left:25%;" />
  <p>&nbsp;</p>
  
  <p>Mauris pharetra varius sagittis. Integer eget dui dolor. Pellentesque iaculis placerat placerat. Morbi a diam ut turpis cursus mattis congue in purus. Vivamus in orci id lorem scelerisque blandit eu sed nunc. Vestibulum finibus tristique sem, quis sollicitudin urna feugiat quis. Integer eu purus at ex fringilla feugiat sit amet in turpis.</p>
  <p>Aenean facilisis faucibus augue, nec aliquam lorem dictum non. Fusce maximus nibh id pretium consectetur. Etiam convallis ipsum quis magna aliquam, in finibus nibh pharetra. Praesent id sapien a augue fringilla tristique. Integer volutpat pharetra nisi, ut convallis leo porta ac. Suspendisse quis justo viverra, blandit turpis quis, volutpat tortor. Cras ultrices neque maximus sodales feugiat. Nam metus quam, tincidunt at diam at, dapibus lobortis leo. Suspendisse eros sapien, imperdiet ut arcu quis, gravida efficitur orci. Donec elit felis, facilisis id ipsum ac, tempus interdum magna.</p>
  `

  return (
    <ArticleContainer >
      <Row className='article-title'>{props.title?props.title:'Title'}</Row>
      <InnerHtml className='article-body' html={props.article?props.article:content}/>
      <Row justify='space-around' className='article-button-row'>
        <Col>
          {props.button && <Button text={props.button.text} href={props.button.link} onClick={props.button.onClick} disabled={props.button.disabled} width={props.button.width}/>}
        </Col>
      </Row>
    </ArticleContainer>
    )
  
}

export default Article
